import { Box, Typography } from "@mui/material";
import BookingsTable from "./components/BookingsTable.jsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import React, { useEffect, useState } from "react";
import { useBreadcrumb } from "../../../contexts/BreadcrumbContext.jsx";
import { PageHeader } from "../../../theme/components/index.js";
import PaymentImportIndexPage from "./PaymentImportIndexPage.jsx";
import BookingExportIndexPage from "./BookingExportIndexPage.jsx";

export default function BookingIndexPage(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeTab } = useParams();

  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", color: "secondary", path: "/home" },
      {
        name: "Buchungsverwaltung",
        color: "primary",
        path: "/admin/buchungen",
      },
    ]);
  }, [setBreadcrumbs]);

  const [value, setValue] = useState("1");

  useEffect(() => {
    if (location.pathname === "/admin/buchungen/exports") {
      setValue("2");
    } else if (location.pathname === "/admin/buchungen/imports") {
      setValue("3");
    } else {
      setValue("1");
    }
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case "1":
        navigate("/admin/buchungen");
        break;
      case "2":
        navigate("/admin/buchungen/exports");
        break;
      case "3":
        navigate("/admin/buchungen/imports");
        break;
      default:
        setValue(newValue);
    }
  };

  console.log("[RENDER] BookingIndexPage");

  return (
    <>
      <PageHeader
        title="Buchungsverwaltung"
        subtitle="Schnittstelle für die Buchungen von Schäden mit den Zahlungsdienstleistern."
      />

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Auszahlungen" value="1" />
              <Tab label="Exporte" value="2" />
              <Tab label="Importe" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ paddingX: 0 }}>
            <BookingsTable />
          </TabPanel>
          <TabPanel value="2" sx={{ paddingX: 0 }}>
            <BookingExportIndexPage />
          </TabPanel>
          <TabPanel value="3" sx={{ paddingX: 0 }}>
            <PaymentImportIndexPage />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
